import http from "@/shared/http/http";
import { createIdentityApi } from "./createIdentityApi.mjs";

export const identityApi = createIdentityApi(http);
